/** Mounts the depth prepass sentinel in a scene for as long as the scene renders. */
import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import { createDepthPrepassSentinel } from './depthPrepass';
/** Draws `scene`'s depth prepass before each of its opaque passes, until unmount. Null draws none. */
export function useSceneDepthPrepass(scene) {
    useEffect(() => {
        if (!scene)
            return undefined;
        const sentinel = createDepthPrepassSentinel();
        scene.add(sentinel);
        return () => {
            scene.remove(sentinel);
            sentinel.dispose();
        };
    }, [scene]);
}
/** Mounted once per canvas, for the canvas's own scene. */
export function SceneDepthPrepass() {
    useSceneDepthPrepass(useThree((state) => state.scene));
    return null;
}
//# sourceMappingURL=SceneDepthPrepass.js.map